import React from "react";
import styled, { css, } from "styled-components";
import R from "ramda";
import { Link, } from "react-router-dom";

import * as m from "../style/mixins";
import * as v from "../style/vars";
import { objMap, } from "../../lib/util";

export * from "./Burger";

// --------------------------------------------------

export const GridCell = styled.div`
	${m.bpEach("padding", v.dim.gutter.half)}
	${p => p.flex ? `flex: ${p.flex};` : ""}
`;

export const TextBox = styled.div`
	${m.bpEach("margin", objMap(v.font.size, (key, val) => `-${val} 0`))}
	${p => p.bold ? "font-weight: bold;" : ""}
	${p => p.align ? `text-align: ${p.align};` : ""}
`;

export const TextCell = props => (
	<GridCell { ...props }>
		<TextBox { ...R.pick([ "bold", "align", ])(props) }>
			{ props.children }
		</TextBox>
	</GridCell>
);
export const Para = props => (
	<div>
		{
			props.children
			.split("\n")
			.map((p, i) => <p key = { `${p.slice(0,5)}/${i}` }>{ p }</p>)
		}
	</div>
);

export const FullWidthImg = styled.img`
	width: 100%;
	height: auto;
`;

const IconWrapper = styled.i`
	font-size: ${p => p.size || "1em"};
	margin-right: ${p => p.marginRight || 0};
`;

export const Icon = props => (
	<IconWrapper className = "material-icons" { ...props }>
		{ props.type }
	</IconWrapper>
);

export const ButtonWrapper = styled.div`
	display: inline-block;
	padding: 0 1.3em;
	border-radius: 1.3em;
	line-height: 1;
	height: 2.6em;
	background: ${p => p.color || v.colors.text};
	transition: 0.1s linear background;
	cursor: pointer;
	color: white;
	${p => p.margin ? "margin: 0.3em;" : ""}
	display: inline-flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	&:hover,
	&:visited,
	&:active {
		color: white;
	}

	&:hover {
		background: ${p => p.hoverColor || (p.color ? m.darken(p.color, 0.1) : m.lighten(v.colors.text, 0.1))};
	}
`;

const IconSpan = styled.span`
	display: inline-block;
`;

const MaybeLink = props => {
	if (props.to) {
		return <Link to = { props.to } children = { props.children }/>
	}
	else if (props.href) {
		return <a href = { props.href } children = { props.children } target = { props.target }/>
	}
	else {
		return props.children;
	}
}

export const IconButton = props => {
	// const ButtonWrapper = props.to ? ButtonLink : ButtonA;

	return (
		<MaybeLink { ...props }>
			<ButtonWrapper { ...props }>
				{
					props.icon
					? <Icon
						type = { props.icon }
						size = "1.2em"
						marginRight = "0.25em"
					/>
					: null
				}
				<IconSpan>{ props.text || props.children }</IconSpan>
			</ButtonWrapper>
		</MaybeLink>
	);	
};

export const Button = IconButton;

export const ContainedImage = styled.div`
	width: 100%;
	padding-top: ${p => p.height || "100%"};
	background-color: ${p => p.bg || "transparent"};
	background-image: url(${R.prop("src")});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;

`;

const textInputLineHeight = 1.4;
const defaultPadding = 1;

const textInputStyle = css`
	border: 1px solid rgba(0,0,0,0.2);
	border-radius: 0.2em;
	font-size: 1em;
	font-family: sans-serif;
	padding: ${p => p.padding || defaultPadding}em;
	line-height: ${textInputLineHeight};
	width: 100%;
`;

export const TextInput = styled.input`
	${textInputStyle}
`;

export const TextArea = styled.textarea`
	${textInputStyle}
	height: ${p => (
		((p.lines || 4) * textInputLineHeight)
		+ (2 * (p.padding || defaultPadding))
	)}em;
	resize: ${p => p.resize || "none"};
`;

export const Main = styled.main`
	margin-top: ${v.dim.nav.height};
	min-height: calc(100vh - ${v.dim.nav.height});
`;



// WEBPACK FOOTER //
// ./src/components/common/misc.js